import {
  DatePicker,
  type DatePickerProps,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { type Theme, ThemeProvider, createTheme } from "@mui/material/styles";
import { forwardRef } from "react";

export type DatePickerInputProps = DatePickerProps & {
  fullWidth?: boolean;
  helperText?: string;
  error?: boolean;
  errorText?: string;
  required?: boolean;
  "data-testid"?: string;
};

export const DatePickerInput = forwardRef<any, DatePickerInputProps>(
  (
    {
      helperText = "",
      fullWidth = true,
      error = false,
      errorText = "",
      required = false,
      label,
      "data-testid": dataTestId,
      ...rest
    },
    ref
  ) => {
    const userTheme = (theme: Theme) =>
      createTheme({
        ...theme,
        components: {
          ...theme.components,
          MuiPaper: {}, // Resets Paper props so background isn't grey in light mode
        },
      });

    return (
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <ThemeProvider theme={userTheme}>
          <DatePicker
            {...rest}
            inputRef={ref}
            label={label}
            slotProps={{
              ...rest.slotProps,
              textField: {
                ...(dataTestId && { "data-testid": dataTestId }), // adds data-testid if provided, and dodges the TS error, since data-testid is not present in the type
                ...rest.slotProps?.textField,
                error,
                fullWidth,
                helperText: errorText || helperText,
                required,
              },
            }}
          />
        </ThemeProvider>
      </LocalizationProvider>
    );
  }
);
